import { MetamaskDownloadLinks, CoreDownloadLinks, UserAgent, WalletNames } from 'types';

import coinbaseIcon from 'assets/images/wallets/coinbase.png';
import coreWalletIcon from 'assets/images/wallets/core-wallet.svg';
import metamaskIcon from 'assets/images/wallets/metamask.png';
import walletConnectIcon from 'assets/images/wallets/wallet-connect.png';
import extentionIcon from 'assets/images/wallets/extention.png';

export const redirectToMetamaskDownload = (userAgent: string) => {
  let walletExtentionDownloadUrl = MetamaskDownloadLinks.NativeWebsite;
  switch (userAgent) {
    case UserAgent.Chrome:
      walletExtentionDownloadUrl = MetamaskDownloadLinks.Chrome;
      break;

    case UserAgent.Firefox:
      walletExtentionDownloadUrl = MetamaskDownloadLinks.Firefox;
      break;

    case UserAgent.Edge:
      walletExtentionDownloadUrl = MetamaskDownloadLinks.Edge;
      break;

    case UserAgent.Opera:
      walletExtentionDownloadUrl = MetamaskDownloadLinks.Opera;
      break;

    default:
      break;
  }
  window.open(walletExtentionDownloadUrl, '_blank')?.focus();
};

export const redirectToCoreDownload = (userAgent: string) => {
  let walletExtentionDownloadUrl = CoreDownloadLinks.NativeWebsite;
  if (userAgent === UserAgent.Chrome) {
    walletExtentionDownloadUrl = CoreDownloadLinks.Chrome;
  }
  window.open(walletExtentionDownloadUrl, '_blank')?.focus();
};

export const renderImage = (name: string): string => {
  switch (name) {
    case WalletNames.Coinbase:
      return coinbaseIcon;

    case WalletNames.WalletConnect:
      return walletConnectIcon;

    case WalletNames.Core:
      return coreWalletIcon;

    case WalletNames.Metamask:
      return metamaskIcon;

    default:
      return extentionIcon;
  }
};
